import React, { useEffect, useCallback } from 'react';
import { Badge } from 'antd';
import { withRouter } from 'react-router';
import { NavLink as Link } from 'react-router-dom';
import Icon from 'common/components/IconFont';
import NoticeApi from 'pc-sales/api.v2/notice';

/**
 * 合并样式
 * @returns {any}
 */
const styleCompose = (data: any) => {
    const { offset, style = {} } = data;
    return offset
        ? {
              marginTop: offset[0],
              marginLeft: offset[1],
              ...style,
          }
        : style;
};

const ReadNotice: React.FC<any> = (props) => {
    const { counts, history } = props;

    const checkForce = useCallback(async () => {
        const data = await NoticeApi.forceList();
        if (
            data.length &&
            '/notification/message/all/detail/force' !==
                history?.location?.pathname
        ) {
            history.push('/notification/message/all/detail/force');
        }
    }, []);

    useEffect(() => {
        let isUnmount = false;
        if (isUnmount) return null;
        checkForce().catch();
        return () => {
            isUnmount = true;
        };
    }, []);

    return (
        <div className="Badge">
            <Link to="/notification/list/all">
                <Badge count={counts || 0} style={styleCompose(props)}>
                    <Icon className="anticon-news" />
                </Badge>
            </Link>
        </div>
    );
};
export default (withRouter as any)(ReadNotice);
